import React from "react";
import {SBL_BuilderPageMain} from "../interfaces";
import SelectedProductImg from "./selected-product-img";
import {Popup} from "../../../ui/popup/popup";


/**
 * View Product PopupProps
 */
interface IViewProductPopupProps {
    product:SBL_BuilderPageMain,
    closePopup: () => void
}
const ViewProductPopup = (props:IViewProductPopupProps) => {

    return (
        <Popup width="300px" height="auto" close={ props.closePopup }>

            <div className="pb-4">
                <SelectedProductImg relativePath={props.product.thumb} />
                <div className="font-bold">{props.product.skuName}</div>
                <div className="py-4">{props.product.documentPageDescription}</div>
                <a href={props.product.documentUrlPath} target="_blank" rel="noreferrer" >{`Explore >`} </a>
            </div>

        </Popup>
    );
};

export default ViewProductPopup;
